import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { MaterialInPopup } from './MaterialInTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class MaterialIn extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            materialObject: {
                idMaterialIn: 0,
                srNo: '',
                date: '',
                idMaterialOut: 0,
                updateStatus: 0,
                materialList: [],
                gatepass: '',
                invoiceNo: '',
                invDate: '',
                idSupplier: 0,
                supplierList: [],
                idInward: 0,
                inwardList: [],
                itemList: [],
                itemListColdefs: [],
                eDate: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForMaterial: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                idMaterialOut: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "material"
                        ),
                    },
                ],
                idSupplier: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "Supplier"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownAndCountsForOtherForms();
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material IN",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialIn"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material IN",
                            colName: colName
                        }, () => {
                            // this.procSelectAllRecord2GridviewSP(id, "Material IN");
                            this.setPermissions(permissions);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.04,
            "challanNo": window.innerWidth * 0.04,
            "challandate": window.innerWidth * 0.06,
            "vendor": window.innerWidth * 0.29,
            "invoiceNo": window.innerWidth * 0.04,
            "invoiceDate": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    // procSelectAllRecord2GridviewSP = (id, formname) => {
    //     let request = {
    //         id: id,
    //         formname: formname,
    //         allowToRateVisible: 1,
    //     }
    //     if (id > 0) {
    //         this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
    //             if (response.statusCode == 200 && response.responseItem !== null) {
    //                 const dynamicData = response.responseItem.responseContent;
    //                 if (dynamicData.length > 0) {
    //                     const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
    //                         field: key,
    //                         headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
    //                         filter: true,
    //                         floatingFilter: true,
    //                     }));
    //                     this.setState({
    //                         table2Data: dynamicData,
    //                         table2ColDefs: dynamicColDefs,
    //                         isTable2Expanded: true
    //                     });
    //                 }
    //             }
    //         });
    //     }
    // }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            this.getAllDropdownAndCountsForOtherForms();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getTransactionMaterialInSelectbyId(event.data.idMaterialIn);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details }, () => {
            if (name === 'gatepass') {
                this.getGatePassSelectbyId();
            }
        });
    }

    handleChangeForDropdown = (event, name) => {
        //debugger;
        let details = this.state.materialObject;
        let value = event.value;
        // if (name === 'rateOn' || name === 'itemType') {
        //     details[name] = event.label;
        // } else {
        details[name] = value;
        //}
        this.setState({ materialObject: details }, () => {
            if (name === 'idSupplier') {
                this.getMaterialOutSelect_ForMaterialIn()
            }
            if (name === 'idMaterialOut') {
                this.getTransactionMaterialOutSelectbyId()
            }
            // else if (name === 'oldProductID') {
            //     this.getMaster_ProductReceipeSelectbyId(value)
            // } else if (name === 'itemTypeId' || name === 'itemTypeId2') {
            //     this.getMaster_ItemSelectbyItemType(event.label, name);
            // } else if (name === 'itemId2') {
            //     this.getMaster_ItemSelectbyID(value);
            // }
        });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let materialObject = this.state.materialObject
        materialObject.idMaterialIn = 0;
        materialObject.srNo = '';
        materialObject.date = '';
        materialObject.idMaterialOut = 0;
        materialObject.updateStatus = 0;
        materialObject.materialList = [];
        materialObject.gatepass = '';
        materialObject.invoiceNo = '';
        materialObject.invDate = '';
        materialObject.idSupplier = 0;
        //materialObject.supplierList = [];
        materialObject.idInward = 0;
        materialObject.inwardList = [];
        materialObject.itemList = [];
        materialObject.itemListColdefs = [];
        materialObject.eDate = "";

        this.setState({
            validState: validState,
            materialObject: materialObject
        });
    }

    getAllDropdownAndCountsForOtherForms = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.getAllDropdownAndCountsForOtherForms(request).then((response) => {

            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.materialObject;
                data.srNo = allData.filter(item => item.source === 'MaterialInCount')?.[0].value + 1;
                data.supplierList = allData.filter(item => item.source === 'Master_PartyAccount');
                this.setState({
                    materialObject: data
                }, () => {
                    //this.usp_Master_EmployeeSelect()
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getMaterialOutSelect_ForMaterialIn = () => {
        let request = [this.state.materialObject.idMaterialIn, this.state.materialObject.idSupplier, this.state.materialObject.updateStatus, this.state.idCompany];
        this.otherFormsServices.getMaterialOutSelect_ForMaterialIn(request).then((response) => {

            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.materialObject;
                allData = allData.map((x) => ({
                    value: x.idMaterialOut,
                    label: x.challanNo + ', ' + x.vendor,
                }));
                data.materialList = allData;
                this.setState({
                    materialObject: data
                }, () => {
                    //this.usp_Master_EmployeeSelect()
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getGatePassSelectbyId = () => {
        if (this.state.materialObject.gatepass > 0) {
            //let request = this.state.materialObject.gatepass;
            this.otherFormsServices.getGatePassSelectbyId(this.state.materialObject.gatepass).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let allData = response.responseItem.responseContent[0];
                    let data = this.state.materialObject;
                    // allData = allData.map((x) => ({
                    //     value: x.idMaterialOut,
                    //     label: x.challanNo + ', ' + x.vendor,
                    // }));
                    data.idSupplier = allData.partyName;
                    this.setState({
                        materialObject: data
                    }, () => {
                        //this.usp_Master_EmployeeSelect()
                    });
                } else {
                    //this.usp_Master_EmployeeSelect()
                }
            });
        }
    }

    getTransactionMaterialOutSelectbyId = () => {
        if (this.state.materialObject.idMaterialOut > 0) {
            //let request = this.state.materialObject.gatepass;
            this.otherFormsServices.getTransactionMaterialOutSelectbyId(this.state.materialObject.idMaterialOut).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let allData = response.responseItem.responseContent[1];
                    this.manageTypeSelection(allData);
                } else {
                    //this.usp_Master_EmployeeSelect()
                }
            });
        }
    }

    manageTypeSelection = (data) => {
        let itemObject = this.state.materialObject;

        if (data.length > 0) {
            data.map((x, key) => {
                x.Select = false
                // x.costingRate = x.stockRate;
                // x.actualRate = x.itemRate;
                // x.rate = 0;
            });
            const columnPriority = [
                "Select", "item", "pendingQty", "quantity"
            ];

            const allKeys = Object.keys(data[0]);
            const sortedKeys = allKeys.sort((a, b) => {
                const indexA = columnPriority.indexOf(a);
                const indexB = columnPriority.indexOf(b);
                if (indexA === -1 && indexB === -1) return 0;
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });

            const dynamicData = sortedKeys.map((key) => {
                const isSelectColumn = key === "Select";

                return {
                    field: key.includes(".") ? key.replace(/\./g, "_") : key,
                    headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                    minWidth:
                        // this.getColumnWidth3(key) !== undefined
                        // ? this.getColumnWidth3(key)
                        // : 
                        window.innerWidth * 0.06,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                    hide: ["idMaterialOut", "amount", "idMaterialOutItems", "itemRemarks", "rate", "recvQty", "ssmA_TimeStamp"].includes(key),
                    width: this.getPinnedWidth(key),
                    valueGetter: (params) => params.data[key],
                    ...(isSelectColumn && {
                        //Render checkbox in cell, not for row selection
                        cellRenderer: 'agCheckboxCellRenderer',
                        editable: true,
                    }),
                };
            });
            itemObject.itemList = data;
            itemObject.itemListColdefs = dynamicData;

            this.setState({ materialObject: itemObject });
        } else {
            itemObject.itemList = [];
            itemObject.itemListColdefs = [];
            this.setState({ materialObject: itemObject });
        }
    };

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    submit = () => {
        let details = this.state.materialObject;
        //debugger;
        let requestData = {
            idMaterialIn: details.idMaterialIn,
            updateStatus: details.updateStatus,
            date: details.date,
            idVendor: details.idSupplier,
            idMaterialOut: details.idSupplier,  // idMaterialOut
            invoiceNo: details.invoiceNo,
            invoiceDate: details.invDate,
            idCompany: this.state.idCompany,
            e_Date: details.eDate && details.eDate !== 'Invalid date' ? details.eDate : new Date().toISOString(),
            e_IdUser: this.state.idUser,
            isUpdated: details.updateStatus > 0 ? 1 : 0,
            updatedDate: details.updateStatus > 0 ? new Date().toISOString() : null,
            uIdUser: details.updateStatus > 0 ? this.state.idUser : 0,
            isDeleted: 0,
            deletedDate: null,
            d_IdUser: 0,
            idGatePass: details.gatepass,
            inwardBy: details.idInward,
            itemList: details.itemList,
        };
        this.otherFormsServices.submitMaterialInInsertUpdate(requestData)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData !== null) {
                        if (dynamicData.errorType === 'Exists') {
                            this.SwalServices.Warning(dynamicData.errorMessage);
                        } else {
                            if (this.state.materialObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated successfully.");
                            } else {
                                this.SwalServices.Success("Saved successfully.");
                            }
                            this.resetDetailsFields();
                            // Call resetFields here after submission
                            this.setState(
                                { isModalOpen: false },
                                () => {
                                    this.procSelectAllRecordsSP(); // Fetch latest records
                                }
                            );
                        }
                    } else {
                        this.procSelectAllRecordsSP();
                    }
                } else {
                    this.setState(
                        { isModalOpen: false },
                        () => {
                            this.SwalServices.Error(response.message);
                            this.procSelectAllRecordsSP(); // Fetch latest records
                        }
                    );
                }
            });
    };

    getTransactionMaterialInSelectbyId = (id) => {
        this.otherFormsServices.getTransactionMaterialInSelectbyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0][0];
                let itemRecord = response.responseItem.responseContent[1];
                let itemObject = this.state.materialObject;
                itemObject.idMaterialIn = data.idMaterialIn;
                itemObject.srNo = data.idMaterialIn;
                itemObject.date = moment(data.date).format('YYYY-MM-DD');
                itemObject.idMaterialOut = data.idMaterialOut;
                itemObject.updateStatus = 1;
                //itemObject.materialList = [];
                itemObject.gatepass = data.idGatePass;
                itemObject.invoiceNo = data.invoiceNo;
                itemObject.invDate = moment(data.invoiceDate).format('YYYY-MM-DD');
                itemObject.idSupplier = data.idVendor;
                //itemObject.supplierList = [];
                itemObject.idInward = data.inwardBy;
                //itemObject.inwardList = [];

                //itemObject.itemListColdefs = dynamicData;
                itemObject.eDate = data.e_Date;
                itemObject.itemListColdefs = [];
                itemObject.itemList = [];
                //};
                //itemObject.drawingNo = data.drawingNo;
                //itemObject.itemTypeId2 = data.itemType ? itemObject.types.find(x => x.label === data.itemType).value  = 0;
                if (itemRecord.length > 0) {
                    itemRecord.map((x, key) => {
                        x.Select = false
                    });
                    const columnPriority = [
                        "Select", "item", "pendingQty", "quantity"
                    ];

                    const allKeys = Object.keys(itemRecord[0]);
                    const sortedKeys = allKeys.sort((a, b) => {
                        const indexA = columnPriority.indexOf(a);
                        const indexB = columnPriority.indexOf(b);
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });

                    const dynamicData = sortedKeys.map((key) => {
                        const isSelectColumn = key === "Select";

                        return {
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth:
                                // this.getColumnWidth3(key) !== undefined
                                // ? this.getColumnWidth3(key)
                                // : 
                                window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialOut", "amount", "idMaterialOutItems", "itemRemarks", "rate", "recvQty", "ssmA_TimeStamp"].includes(key),
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            ...(isSelectColumn && {
                                //Render checkbox in cell, not for row selection
                                cellRenderer: 'agCheckboxCellRenderer',
                                editable: true,
                            }),
                        };
                    });
                    itemObject.itemListColdefs = dynamicData;

                    itemObject.itemList = itemRecord;

                }
                this.setState({
                    materialObject: itemObject,
                    isModalOpen: true
                });
                let req = [data.idMaterialIn, data.idVendor, 1, this.state.idCompany];
                this.otherFormsServices.getMaterialOutSelect_ForMaterialIn(req).then((res) => {
                    if (res.statusCode == 200 && res.responseItem !== null) {
                        let allData = res.responseItem.responseContent;
                        //let data = this.state.materialObject;
                        allData = allData.map((x) => ({
                            value: x.idMaterialOut,
                            label: x.challanNo + ', ' + x.vendor,
                        }));
                        itemObject.materialList = allData;
                        this.setState({
                            materialObject: itemObject
                        });
                    }
                });
            }
        });
    }

    render() {
        return (
            <div className='material-in'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MaterialInPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            handleChange={this.handleChange.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material in</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
